module.exports = __webpack_public_path__ + "img/c8cf8ca70d77fee7ebe6814c32065b17.png";